import React, { useState, useRef, useEffect } from 'react';

const FilteringSelect = ({ options, value, onChange, placeholder, name, id, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [displayValue, setDisplayValue] = useState('');
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter(option => 
    option.countryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedOption = options.find(option => option.countryCode === value);

  useEffect(() => {
    if (selectedOption) {
      setDisplayValue(selectedOption.countryName);
    } else {
      setDisplayValue('');
    }
  }, [selectedOption]);

  useEffect(() => {
    if (isOpen) {
    } else {
      setSearchTerm('');
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputClick = () => {
    if (!disabled) {
      setIsOpen(true);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true); 
  };

  const handleOptionClick = (option) => {    
    setDisplayValue(option.countryName);
    
    onChange({ target: { name, value: option.countryCode } });
    
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      <input
        type="text"
        className={`form-control  filtering-select ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        placeholder={placeholder}
        value={isOpen ? searchTerm : displayValue}
        onChange={handleInputChange}
        onClick={handleInputClick}
        disabled={disabled}
        readOnly={!isOpen} 
        
      />
      <img 
        src={disabled ? process.env.PUBLIC_URL + 'images/arrow-down-disabled.png': process.env.PUBLIC_URL + 'images/arrow-down.png'}
        className="position-absolute top-50 end-0 translate-middle-y pe-2 cursor-pointer"
        onClick={handleInputClick}
        alt="arrow-down"
      />

      {isOpen && (
        <div className="position-absolute start-0 w-100 border rounded mt-1 bg-white shadow filtering-select-container" >
          <ul className="list-group list-group-flush">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <li
                  key={option.countryCode}
                  className={`list-group-item ${option.countryCode === value ? 'active' : ''} cursor-pointer`}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.countryName}
                </li>
              ))
            ) : (
              <li className="list-group-item text-center">Aucun résultat trouvé</li> // a modifier par la trad
            )}
          </ul>
        </div>
      )}
      
      <input
        type="hidden"
        id={id}
        name={name}
        value={value || ''}
      />
    </div>
  );
};

export default FilteringSelect;